(() => {
  if (customElements.get('delulu-reels')) return;

  class DeluluReels extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('[data-delulu-scroll-target]').forEach((button) => {
        if (button.dataset.ready === 'true') return;
        button.dataset.ready = 'true';
        button.addEventListener('click', () => {
          const target = document.getElementById(button.dataset.deluluScrollTarget);
          if (!target) return;
          const direction = button.dataset.direction === 'previous' ? -1 : 1;
          target.scrollBy({ left: target.clientWidth * 0.82 * direction, behavior: 'smooth' });
        });
      });

      this.videos.forEach((video) => {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.setAttribute('aria-label', 'Delulu play moment video');

        if (this.prefersReducedMotion) {
          video.pause();
          video.removeAttribute('autoplay');
        }
      });

      if (this.prefersReducedMotion || this.videos.length === 0) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.35, rootMargin: '120px 0px' }
        );

        this.videos.forEach((video) => this.observer.observe(video));
      } else {
        this.videos.forEach((video) => video.play().catch(() => {}));
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('delulu-reels', DeluluReels);
})();
